import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { Seo } from "@/lib/seo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  return (
    <>
      <Seo title="Admin Login" description="AstroLife administration" path="/admin/login" />
      <div className="flex min-h-screen items-center justify-center bg-navy px-5">
        <div className="w-full max-w-md">
          <div className="mb-8 flex justify-center"><Logo /></div>
          <form onSubmit={submit} className="rounded-2xl border border-navy-border bg-navy-surface p-8" data-testid="admin-login-form">
            <div className="mb-6 flex items-center gap-3">
              <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-astro-blue/10 text-astro-light">
                <Lock className="h-5 w-5" />
              </div>
              <div>
                <h1 className="font-heading text-xl font-bold text-white">Administration</h1>
                <p className="text-sm text-silver/50">Sign in to continue</p>
              </div>
            </div>
            {error && <div className="mb-4 rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-300" data-testid="admin-login-error">{error}</div>}
            <label className="mb-4 block">
              <span className="mb-2 block text-sm font-medium text-silver/80">Email</span>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" className="w-full rounded-xl border border-navy-border bg-navy px-4 py-3 text-sm text-white focus:border-astro-blue focus:outline-none" />
            </label>
            <label className="mb-6 block">
              <span className="mb-2 block text-sm font-medium text-silver/80">Password</span>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" className="w-full rounded-xl border border-navy-border bg-navy px-4 py-3 text-sm text-white focus:border-astro-blue focus:outline-none" />
            </label>
            <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full rounded-full bg-astro-blue px-6 py-3.5 font-semibold text-white hover:bg-astro-light transition-colors disabled:opacity-60">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
